import React from 'react';
import { Box, Typography } from '@mui/material';
import ReactJson from 'react-json-view';
import useStyles from './style.js';

/**
 * @name ChangeLogsDetailsModal
 * @description Component to display detailed change log information in a modal.
 * It shows different types of changes (modified or other types) based on the mode.
 * @param {Object} props - Component properties.
 * @param {Array} props.featureKeyData - The data for the feature key to display in the modal.
 * @param {string} props.mode - The mode of the change ('modified', 'added', 'deleted').
 * @param {string} props.featureKey - The key representing the feature for which changes are shown.
 * @returns {JSX.Element} - The rendered component.
 */
const ChangeLogsDetailsModal = ({ featureKeyData, mode, featureKey }) => {
	const classes = useStyles();

	return (
		<Box className={classes.modalContainer}>
			<Typography variant="h5">
				<span>Feature : </span>
				<span className={classes.title}>{featureKey}</span>
			</Typography>

			{mode === 'modified' && (
				<>
					<Typography variant="h4" className={classes.updateType}>
						Modified
					</Typography>

					{featureKeyData.map((item) => (
						<Box className={classes.boxContainer} key={item.path} mb={2}>
							<Typography component="span" sx={{ color: '#fc4b58' }}>
								Path :
							</Typography>
							<Typography component="span" sx={{ color: '#0369a1', fontWeight: 'bold' }}>
								{`  ${item.path}`}
							</Typography>
							<Box mt={1} />
							<Typography component="span" sx={{ color: '#fc4b58' }}>
								From :
							</Typography>
							<Typography component="span">
								{typeof item.from !== 'object' ? (
									`  ${item.from}`
								) : (
									<ReactJson
										name={false}
										style={{ marginLeft: '1rem' }}
										enableClipboard={true}
										displayDataTypes={false}
										src={item.from}
									/>
								)}
							</Typography>
							<Box mt={1} />
							<Typography component="span" sx={{ color: '#fc4b58' }}>
								To :
							</Typography>
							<Typography component="span">
								{typeof item.to !== 'object' ? (
									`  ${item.to}`
								) : (
									<ReactJson
										name={false}
										style={{ marginLeft: '1rem' }}
										enableClipboard={true}
										displayDataTypes={false}
										src={item.to}
									/>
								)}
							</Typography>
						</Box>
					))}
				</>
			)}

			{mode !== 'modified' && (
				<>
					<Typography variant="h4" className={classes.updateType} textTransform="capitalize">
						{mode}
					</Typography>
					{featureKeyData.map((item) => (
						<Box className={classes.boxContainer} key={item.path} mb={2}>
							<Typography component="span" sx={{ color: '#fc4b58' }}>
								Path :
							</Typography>
							<Typography component="span" sx={{ color: '#0369a1', fontWeight: 'bold' }}>
								{`  ${item.path}`}
							</Typography>
							<Box mt={1} />
							<Typography component="span" sx={{ color: '#fc4b58' }}>
								Value :
							</Typography>
							<Typography component="span">
								{typeof item.value !== 'object' ? (
									`  ${item.value}`
								) : (
									<ReactJson
										name={false}
										style={{ marginLeft: '1rem' }}
										enableClipboard={true}
										displayDataTypes={false}
										src={item.value}
									/>
								)}
							</Typography>
						</Box>
					))}
				</>
			)}
		</Box>
	);
};

export default ChangeLogsDetailsModal;
